import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// Components
import { FullPageWidth } from '../../components/global/FullPageWidth/FullPageWidth';
import { BillboardBannerAd } from 'dibs-google-ad-manager/exports/BillboardBannerAd';

// Helpers
import { getBillboardAdData } from 'dibs-google-ad-manager/exports/adHelpers';

import { type AdBillboardWidth } from 'dibs-google-ad-manager/exports/types';

import { type SbSharedBillboardAd_itemSearch$key } from './__generated__/SbSharedBillboardAd_itemSearch.graphql';

const itemSearchFragment = graphql`
    fragment SbSharedBillboardAd_itemSearch on ItemSearchQueryConnection {
        displayUriRef
    }
`;

type Props = {
    itemSearch: SbSharedBillboardAd_itemSearch$key;
    adWidth?: AdBillboardWidth;
    className?: string;
};

export const SbSharedBillboardAd: FC<Props> = ({
    itemSearch: itemSearchRef,
    adWidth = 'mobile',
    className,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const displayUriRef = itemSearch?.displayUriRef ?? '';
    const billboardAdData = getBillboardAdData(displayUriRef)?.[adWidth];

    if (!billboardAdData) {
        return null;
    }

    return (
        <FullPageWidth className={className}>
            <BillboardBannerAd {...billboardAdData} lazyLoad />
        </FullPageWidth>
    );
};
